import { z } from 'zod';

export const zodInvoiceParsingInputEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
  z.literal('parsing_input'),
]);

export const zodInvoiceParsingInputFileTypeSchema = z.enum([
  'application/json',
  'application/xml',
]);

export const zodInvoiceParsingInputResponseSchema = z.object({
  content: z.string(),
  filetype: zodInvoiceParsingInputFileTypeSchema,
});
